module.exports = __webpack_public_path__ + "img/sub4.f21bd5c9.jpg";